
/**
 * Helper
 */
var helper = require('../../helper');

$(function() {

    $.fn.dataTable.moment( 'DD/MM/YYYY' );

    var $datatable = $('#datatable-all-tickets-of-property-for-mir'),
        $propertyId = $datatable.data('property'),
        dataTables_buttons = [
            {
                extend: 'colvis'
            }
        ];

 //   console.log($propertyId);
  //  console.log($('#month').val());

    var table = $datatable.DataTable({
        "dom": "<'dt-toolbar'lfB>tr<'row'<'col-sm-5'i><'col-sm-7'p>>",
        "processing": true,
        "serverSide": true,
        "responsive": true,
        "lengthMenu": [[ 50, 75, 100], [ 50, 75, 100]],
        "ajax": {
            "url": helper.getOrigin() + "/api/tickets/property/" + $propertyId + "/monthly-initial-report",
            "method": 'POST',

            "data": function ( d ) {
                d.month = $('#month').val();
                d.year = $('input[id="year"]').val();
            }
        },
        "autoWidth" : false,
        "buttons": dataTables_buttons,
        "displayLength": 10,
        "order": [[ 0, "desc" ]],
        "columns": [
            {data: 'ticket_id', name: 'id'},
            {data: 'status', name: 'status.name'},
            {data: 'urgency', name: 'urgency.name'},
            {data: 'property_id', name: 'property.property_id', visible: false},
            {data: 'property_name', name: 'property.name'},
            {data: 'postcode', name: 'property.postcode'},
            {data: 'created_at', name: 'created_at'},
            {data: 'date_estimated_completion', name: 'date_estimated_completion'},
            {data: 'date_completed', name: 'date_completed'},
            {data: 'job_type', name: 'type.name'},
            {data: 'client_view', name: 'client_view', width: "1%"},
            {data: 'contact_first_name', name: 'user.first_name', visible: false},
            {data: 'contact_last_name', name: 'user.last_name', visible: false},
            {data: 'contractor', name: 'contractor.name', visible: false},
            {data: 'actions', name: 'actions', orderable: false, searchable: false, className : "action hidden-print", width: '60px'}
        ]
        ,
        'columnDefs': [{
            'targets': 10,
            'searchable':true,
            'orderable':false,
            'className': 'dt-body-center tiny-column',
            'render': function (data, type, full, meta){

                if (data[0] == 1) { // if field in database is 1 (checked)
                    return '<input id="client_view-'+data[1]+'" data-ticket-id="'+data[1]+'" type="checkbox" name="client_view[]" value="1" checked>';
                } else {
                    return '<input id="client_view-'+data[1]+'" data-ticket-id="'+data[1]+'" type="checkbox" name="client_view[]" value="0">';
                }

            }
        }]
    });

    $('.js-mir-change-field').on('change', function() {
    //    console.log('change!');

        table.ajax.reload();
    });

});
